/** Llamadas HTTP del feature tarifas. */
import { apiRequest } from "../../lib/api";

export type EstadoVigencia = "vigente" | "historico";

export interface TarifaRead {
  id: number;
  empresa_id: number;
  nombre: string;
  porcentaje_alcantarillado: number;
  created_at: string;
  updated_at: string;
}

export interface TarifaBaseRead {
  id: number;
  empresa_id: number;
  tarifa_id: number;
  cargo_fijo_agua: number;
  cargo_fijo_alc: number;
  fondo_reposicion: number;
  otros_cargos: number;
  descripcion: string | null;
  fecha_inicio_vigencia: string;
  fecha_fin_vigencia: string | null;
  estado: EstadoVigencia;
  created_at: string;
  updated_at: string;
}

export interface TramoTarifaRead {
  id: number;
  empresa_id: number;
  tarifa_id: number;
  desde_m3: number;
  hasta_m3: number | null;
  valor_unitario: number;
  estado: EstadoVigencia;
  fecha_inicio_vigencia: string;
  fecha_fin_vigencia: string | null;
  created_at: string;
  updated_at: string;
}

export interface TarifaDetailRead extends TarifaRead {
  base_vigente: TarifaBaseRead | null;
  tramos_vigentes: TramoTarifaRead[];
}

export interface TarifaCreatePayload {
  nombre: string;
  porcentaje_alcantarillado?: number;
}

export interface TarifaUpdatePayload {
  nombre?: string;
  porcentaje_alcantarillado?: number;
}

export interface NuevaVigenciaBasePayload {
  fecha_inicio_vigencia: string;
  cargo_fijo_agua?: number;
  cargo_fijo_alc?: number;
  fondo_reposicion?: number;
  otros_cargos?: number;
  descripcion?: string | null;
}

export interface TramoEnVigenciaInput {
  desde_m3: number;
  hasta_m3: number | null;
  valor_unitario: number;
}

export interface NuevaVigenciaTramosPayload {
  fecha_inicio_vigencia: string;
  tramos: TramoEnVigenciaInput[];
}

export function listarTarifas(): Promise<TarifaRead[]> {
  return apiRequest<TarifaRead[]>("/api/v1/tarifas");
}

export function obtenerTarifa(
  id: number,
  fecha?: string,
): Promise<TarifaDetailRead> {
  const qs = fecha ? `?fecha=${fecha}` : "";
  return apiRequest<TarifaDetailRead>(`/api/v1/tarifas/${id}${qs}`);
}

export function crearTarifa(p: TarifaCreatePayload): Promise<TarifaRead> {
  return apiRequest<TarifaRead>("/api/v1/tarifas", { method: "POST", body: p });
}

export function actualizarTarifa(
  id: number,
  p: TarifaUpdatePayload,
): Promise<TarifaRead> {
  return apiRequest<TarifaRead>(`/api/v1/tarifas/${id}`, {
    method: "PATCH",
    body: p,
  });
}

export function listarBases(tarifaId: number): Promise<TarifaBaseRead[]> {
  return apiRequest<TarifaBaseRead[]>(`/api/v1/tarifas/${tarifaId}/bases`);
}

export function crearNuevaBase(
  tarifaId: number,
  p: NuevaVigenciaBasePayload,
): Promise<TarifaBaseRead> {
  return apiRequest<TarifaBaseRead>(`/api/v1/tarifas/${tarifaId}/bases`, {
    method: "POST",
    body: p,
  });
}

export function listarTramos(tarifaId: number): Promise<TramoTarifaRead[]> {
  return apiRequest<TramoTarifaRead[]>(`/api/v1/tarifas/${tarifaId}/tramos`);
}

export function crearNuevosTramos(
  tarifaId: number,
  p: NuevaVigenciaTramosPayload,
): Promise<TramoTarifaRead[]> {
  return apiRequest<TramoTarifaRead[]>(`/api/v1/tarifas/${tarifaId}/tramos`, {
    method: "POST",
    body: p,
  });
}
